import React from 'react';
import { Line } from 'react-konva';

export const DrawingLayer = ({ lines }) => {
  return (
    <>
      {lines.map((line, i) => (
        <Line
          key={i}
          points={line.points}
          stroke="#df2d11"
          strokeWidth={3}
          tension={0.5}
          lineCap="round"
          lineJoin="round"
          globalCompositeOperation="source-over"
        />
      ))}
    </>
  );
};

export const useDrawing = (stageRef) => {
  const [lines, setLines] = React.useState([]);
  const [isDrawing, setIsDrawing] = React.useState(false);

  const getRelativePointerPosition = (e) => {
    const stage = stageRef.current;
    if (!stage) return null;
    
    // Get pointer position relative to stage
    const pointer = stage.getPointerPosition();
    if (!pointer) return null;

    // Convert point to relative position
    return {
      x: (pointer.x - stage.x()) / stage.scaleX(),
      y: (pointer.y - stage.y()) / stage.scaleY()
    };
  };

  const handleMouseDown = (e) => {
    if (e.evt.button === 0) { // Left mouse button
      setIsDrawing(true);
      const pos = getRelativePointerPosition(e);
      if (pos) {
        setLines([...lines, { points: [pos.x, pos.y] }]);
      }
    }
  };

  const handleMouseMove = (e) => {
    if (!isDrawing) return;

    const pos = getRelativePointerPosition(e);
    if (!pos) return;

    const lastLine = lines[lines.length - 1];
    if (!lastLine) return;

    // Add point to current line
    lastLine.points = lastLine.points.concat([pos.x, pos.y]);

    // Replace last line with updated one
    setLines([...lines.slice(0, -1), lastLine]);
  };

  const handleMouseUp = () => {
    setIsDrawing(false);
  };

  const clearDrawing = () => {
    setLines([]);
  };

  return {
    lines,
    isDrawing,
    handleMouseDown,
    handleMouseMove,
    handleMouseUp,
    clearDrawing
  };
};